import { render, staticRenderFns } from "./Trucks.vue?vue&type=template&id=a5f2bb02&"
import script from "./Trucks.vue?vue&type=script&lang=js&"
export * from "./Trucks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports